<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messagesPopup"
                           :error="isErrorPopup"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="isErrorPopup = $event"/>
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
          {{ messageHeader }}
        </p>
      </section>
      <section class="mgt-10px">
        <b-field :label="getLabelDate"
                 v-if="isDisplayDate"
                 class="mgt-20px obligatoire">
          <b-datepicker show-week-number
                        icon="calendar-today"
                        :editable="true"
                        nearby-selectable-month-days
                        v-model="date">
          </b-datepicker>
        </b-field>
      </section>
      <footer class="mgt-10px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
          <button class="button is-addOrEdit has-text-centered button-modal"
                  @click="updateEtat">
            {{ $t('general.button.valider') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import { ETAT_EN_COURS, ETAT_PLANIFIE, ETAT_REALISE } from '@/configuration/logistique/audit/auditConf';
import { updateEtatAsync } from '@/api/logistique/audit';
import validation from '@/services/logistique/audit/validation/validation';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import formatDate from '@/services/general/formatIsoDate';

export default {
  props: {
    audit: {
      required: true,
      type: Object,
    },
    etat: {
      required: true,
      type: String,
    },
    messageHeader: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messagesPopup: [],
      isErrorPopup: false,
      date: null,
      constantes: {
        ETAT_REALISE,
        ETAT_PLANIFIE,
        ETAT_EN_COURS,
      },
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    isDisplayDate() {
      return (this.etat === ETAT_REALISE && !this.audit.dateRealisation)
        || (this.etat === ETAT_PLANIFIE && !this.audit.datePlanification);
    },
    getLabelDate() {
      if (this.etat === ETAT_REALISE) return this.$t('detailAudit.popup.dateRealisation');
      return this.$t('detailAudit.popup.datePlanification');
    },
  },
  methods: {
    async updateEtat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesPopup = [];
        this.isErrorPopup = false;
        await updateEtatAsync({
          otsIds: [this.audit.id],
          dateOt: this.date ? formatDate(this.date) : null,
          etatSouhaite: this.etat,
        });
        messageSucces(this.$i18n.t('detailAudit.messages.success.updateEtat'));
        loadingComponent.close();
        this.$emit('update');
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesPopup, []);
          this.isErrorPopup = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    switch (this.etat) {
      case ETAT_REALISE:
        this.date = this.audit.dateRealisation ? new Date(this.audit.dateRealisation) : null;
        break;
      case ETAT_PLANIFIE:
        this.date = this.audit.datePlanification ? new Date(this.audit.datePlanification) : null;
        break;
      default:
        break;
    }
  },
};

</script>
